export function isHexColorLightOrDark(color: string) {
  // Variables for red, green, blue values
  let r: number, g: number, b: number;

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    const rgb = color.match(
      /rgb\((\d+),\s*(\d+),\s*(\d+)\)/
    ) as RegExpMatchArray;
    r = parseInt(rgb[1]);
    g = parseInt(rgb[2]);
    b = parseInt(rgb[3]);
  } else {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    const hex = color.replace("#", "");
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  return hsp > 127.5 ? "black" : "white";
}
